"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_cookie_1 = __importDefault(require("js-cookie"));
var config_1 = require("./config");
var SignUpMetadataManager = /** @class */ (function () {
    function SignUpMetadataManager(options) {
        this.options = options;
    }
    SignUpMetadataManager.prototype.getAll = function () {
        return __assign(__assign({}, this.extractCookieValues(config_1.PARAMS_COOKIE_NAMES)), this.extractCookieValues(config_1.PERSISTENT_METADATA_NAMES));
    };
    SignUpMetadataManager.prototype.cleanAll = function () {
        var _this = this;
        Object.keys(config_1.PARAMS_COOKIE_NAMES).forEach(function (paramName) {
            js_cookie_1.default.remove(config_1.PARAMS_COOKIE_NAMES[paramName], { domain: _this.options.cookiesDomain });
        });
    };
    SignUpMetadataManager.prototype.save = function (data) {
        var _this = this;
        Object.keys(data).forEach(function (key) {
            if (key in config_1.PERSISTENT_METADATA_NAMES) {
                return;
            }
            _this.validateParam(key);
            var cookieName = config_1.PARAMS_COOKIE_NAMES[key];
            var value = data[key];
            if (key in config_1.COOKIES_EXPIRATION) {
                js_cookie_1.default.set(cookieName, value, {
                    domain: _this.options.cookiesDomain,
                    expires: config_1.COOKIES_EXPIRATION[key],
                });
            }
            else {
                js_cookie_1.default.set(cookieName, value, { domain: _this.options.cookiesDomain });
            }
        });
    };
    SignUpMetadataManager.prototype.validateParam = function (param) {
        var allowedParams = Object.keys(config_1.PARAMS_COOKIE_NAMES);
        if (allowedParams.indexOf(param) === -1) {
            throw new Error("Invalid metadata param passed. Allowed params: ".concat(allowedParams.join(', ')));
        }
    };
    SignUpMetadataManager.prototype.extractCookieValues = function (config) {
        return Object.keys(config).reduce(function (data, paramName) {
            var _a;
            var fieldValue = js_cookie_1.default.get(config[paramName]);
            // Don't add metadata field if it's empty
            if (!fieldValue) {
                return data;
            }
            return __assign(__assign({}, data), (_a = {}, _a[paramName] = fieldValue, _a));
        }, {});
    };
    return SignUpMetadataManager;
}());
exports.default = SignUpMetadataManager;
//# sourceMappingURL=signup-metadata.js.map